import { BuildList, BuildListData } from '@/components/BuildList'
import { Hero } from '@/components/Hero'
import { statamicGraphqlEndpoint } from '@/globals/globals'
import { request } from 'graphql-request'

export async function getStaticProps() {
  return {
    props: {
      builds: await request(statamicGraphqlEndpoint, BuildListData()),
    },
    revalidate: 60,
  }
}

export default function Page(props: any) {
  return (
    <>
      <Hero heading='Deboss Garage Builds' />
      <BuildList builds={props.builds} />
    </>
  )
}
